// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__20uPQ","col":"styles_col__CYH-e"};